import { TextField } from '@mui/material';
import { Component } from 'react';

export default class NumEmpInput extends Component {
    render() {
        return (
            <TextField
                {...this.props.props}
                type="number"
                inputProps={{ min: 0 }}
                sx={this.props.sx}
                error={this.props.error === true}
                helperText={this.props.error === true ? "Informe um número" : null}
                size="small"
                variant="outlined"
                name="numemp"
                label={'Núm. Emp.' + (this.props.required ? '*' : '')}
                value={this.props.value}
                onChange={e => this.props.onChange ? this.props.onChange(e.target.value) : {}} />
        );
    }
}